<template>
    <b-modal size="xl" :title="HeaderText" id="confirm-close-fulfillment-modal" hide-footer centered
             v-model="shouldDisplay" class="text-center">
            <img :src="currentPhoto" v-if="currentPhoto" style="width:100%;" alt="">
        <b-aspect aspect="4:3" v-if="currentVideo">
            <video controls :src="currentVideo" width="100%" autoplay></video>
        </b-aspect>
    </b-modal>
</template>

<script>
    export default {
        name: 'PhotoWidget',
        props:{
            HeaderText: {type:String, default: ''}
        },
        data(){
            return {
                currentPhoto: '',
                currentVideo: '',
                shouldDisplay: false,
            };
        },
        methods:{
            renderImage: function(img){
                this.currentVideo = '';
                this.currentPhoto = img;
                this.shouldDisplay = true;
            },
            renderVideo: function(vid){
                this.currentPhoto = '';
                this.currentVideo = vid;
                this.shouldDisplay = true;
            }
        },
    };
</script>

<style scoped>

</style>